import { takeLatest, all, takeEvery, take } from "redux-saga/effects"; // fork, take,  takeEvery, takeLeading
import { SAGA_ACTIONS } from "../../_config";

import * as userSaga from "./userSaga";
import * as commonSaga from "./commonSaga";
import * as categoriesSaga from "./categoriesSaga";
import * as unitsSaga from "./unitsSaga";
import * as attributesSaga from "./attributesSaga";
import * as productsSaga from "./productsSaga";
import * as vendorsSaga from "./vendorsSaga";
import * as brandsSaga from "./brandsSaga";
import * as tagsSaga from "./tagsSaga";
import * as customersSaga from "./customersSaga";
import * as discountsSaga from "./discountsSaga";
import * as inventorySaga from "./inventorySaga";
import * as loyaltySaga from "./loyaltySaga";
import * as loyaltyRewardSaga from "./loyaltyRewardSaga";
import * as loyaltyActivitySaga from "./loyaltyActivitySaga";
import * as settingsReturnSaga from "./settingsReturnSaga";
import * as userManagementSaga from "./userManagement";
import * as giftCardsSaga from "./giftCardsSaga";
import * as notificationsSaga from "./notifications";
import * as orderandfulfillmentSaga from "./orderandfulfillmentSaga";
import * as settingsPaymentTypeSaga from "./settingsPaymentTypeSaga";
import * as businessSaga from "./businessSaga";
import * as  agreementsSaga from "./agreementsSaga";
import * as templateSaga from "./templateSaga";
import * as companySaga from "./companySaga";
import * as taxSaga from "./taxSaga";
import * as additionalTaxSaga from "./additionalTaxSaga";
import * as donationSaga from "./donationSaga";
import * as cashDiscountSaga from "./cashDiscountSaga";
import * as tipSaga from "./tipSaga";
import * as settingsLanguageSaga from "./settingsLanguageSaga";
import * as settingsManualProductTaxableSaga from "./settingsManualProductTaxableSaga";
import * as dashboardSaga from "./dashboardSaga";
import * as reportingSaga from "./reportingSaga";
import * as feedbackSaga from "./feedbackSaga";
import * as productImportSaga from "./productImportSaga";
import * as lotterySaga from "./lotterySaga";
import * as marketingSaga from "./marketingSaga";
import * as depositsSaga from "./depositsSaga";
import * as quickbooksSaga from "./quickbooksSaga";

export function* sagas() {
    yield all([
      takeEvery(SAGA_ACTIONS.USER.LOGIN, userSaga.login),
      takeEvery(SAGA_ACTIONS.USER.LOGOUT, userSaga.logout),
      takeEvery(SAGA_ACTIONS.USER.REGISTER, userSaga.register),
      takeEvery(SAGA_ACTIONS.USER.FORGET_PASSWORD, userSaga.forgotPassword),
      takeEvery(SAGA_ACTIONS.USER.RESET_PASSWORD, userSaga.resetPassword),
      takeEvery(SAGA_ACTIONS.USER.GET_MENUS, userSaga.getMenus),
      takeEvery(SAGA_ACTIONS.USER.GET_USER_ACTIVITY, userSaga.getUserActivity),
      takeEvery(
        SAGA_ACTIONS.USER.LAST_PUNCH_STATUS,
        userSaga.getLastPunchStatus
      ),
      takeEvery(SAGA_ACTIONS.USER.CLOCK_IN, userSaga.clockIn),

        takeEvery(SAGA_ACTIONS.COMMON.GET_CITY, commonSaga.GetCityList),
        takeEvery(SAGA_ACTIONS.COMMON.GET_COUNTY, commonSaga.GetCountyList),
        takeEvery(SAGA_ACTIONS.COMMON.GET_COUNTRY, commonSaga.GetCountryList),
        takeEvery(SAGA_ACTIONS.COMMON.GET_STATE, commonSaga.GetStateList),
        takeEvery(SAGA_ACTIONS.COMMON.LOCATION_SEARCH, commonSaga.locationSearch),
        takeEvery(SAGA_ACTIONS.COMMON.LOOKUP_VALUES, commonSaga.lookupValues),

        // Business
        takeEvery(SAGA_ACTIONS.BUSINESS.STORE_LOCATIONS_LIST, businessSaga.getStoreLocationsList),
        takeEvery(SAGA_ACTIONS.BUSINESS.STORE_LOCATIONS_INSERT_UPDATE, businessSaga.insertUpdateStoreLocation),
        takeEvery(SAGA_ACTIONS.STORAGE.UPLOAD_IMAGE, commonSaga.uploadImage),
        takeEvery(SAGA_ACTIONS.COMMON.GET_CURRENCY, commonSaga.GetCurrencyList),
        takeEvery(SAGA_ACTIONS.COMMON.GET_TIMEZONES, commonSaga.GetTimezones),

      // Categories
      takeEvery(
        SAGA_ACTIONS.CATEGORIES.ADD_UPDATE_CATEGORY,
        categoriesSaga.addUpdateCategory
      ),
      takeEvery(
        SAGA_ACTIONS.CATEGORIES.DELETE_CATEGORY,
        categoriesSaga.deleteCategory
      ),
      takeEvery(
        SAGA_ACTIONS.CATEGORIES.SEARCH_CATEGORY,
        categoriesSaga.searchCategory
      ),
      takeEvery(
        SAGA_ACTIONS.CATEGORIES.CATEGORY_DETAILS,
        categoriesSaga.categoryDetails
      ),
      takeEvery(SAGA_ACTIONS.CATEGORIES.REARRANGE_CATEGORY, categoriesSaga.rearrangeCategory),

      // Units
      takeEvery(SAGA_ACTIONS.UNITS.SEARCH_UNIT, unitsSaga.searchUnit),
      takeEvery(SAGA_ACTIONS.UNITS.ADD_UPDATE_UNIT, unitsSaga.addUpdateUnit),
      takeEvery(SAGA_ACTIONS.UNITS.DELETE_UNIT, unitsSaga.deleteUnit),
      takeEvery(SAGA_ACTIONS.UNITS.UNIT_DETAILS, unitsSaga.unitDetails),

      // Attributes
      takeEvery(
        SAGA_ACTIONS.ATTRIBUTES.SEARCH_ATTRIBUTE,
        attributesSaga.searchAttribute
      ),
      takeEvery(
        SAGA_ACTIONS.ATTRIBUTES.ADD_UPDATE_ATTRIBUTE,
        attributesSaga.addUpdateAttribute
      ),
      takeEvery(
        SAGA_ACTIONS.ATTRIBUTES.DELETE_ATTRIBUTE,
        attributesSaga.deleteAttribute
      ),
      takeEvery(
        SAGA_ACTIONS.ATTRIBUTES.ATTRIBUTE_DETAILS,
        attributesSaga.attributeDetails
      ),

      //Products
      takeEvery(
        SAGA_ACTIONS.PRODUCTS.SEARCH_PRODUCT,
        productsSaga.searchCategory
      ),
      takeEvery(
        SAGA_ACTIONS.PRODUCTS.ADD_UPDATE_PRODUCT,
        productsSaga.addUpdateProduct
      ),
      takeEvery(
        SAGA_ACTIONS.PRODUCTS.DELETE_PRODUCT,
        productsSaga.deleteProduct
      ),
      takeEvery(SAGA_ACTIONS.PRODUCTS.GENERATE_SKU, productsSaga.generateSKU),
      takeEvery(
        SAGA_ACTIONS.PRODUCTS.UPDATE_INVENTORY,
        productsSaga.updateInventory
      ),
      takeEvery(SAGA_ACTIONS.PRODUCTS.UPDATE_PRICES, productsSaga.updatePrices),
      takeEvery(
        SAGA_ACTIONS.PRODUCTS.BULK_UPDATE_PRODUCTS,
        productsSaga.bulkUpdateProducts
      ),
      takeEvery(
        SAGA_ACTIONS.PRODUCTS.STATUS_CHANGE,
        productsSaga.changeProductStatus
      ),
      takeEvery(
        SAGA_ACTIONS.PRODUCTS.NON_TAXABLE_PRODUCT_SEARCH,
        productsSaga.nonTaxableProductSearch
      ),
      takeEvery(
        SAGA_ACTIONS.PRODUCTS.ADD_NON_TAXABLE_PRODUCT,
        productsSaga.addNonTaxableProduct
      ),
      takeEvery(SAGA_ACTIONS.PRODUCTS.CHECK_SKU_UNIQUE, productsSaga.checkSKUUnique),
      takeEvery(
        SAGA_ACTIONS.PRODUCTS.REARRANGE_PRODUCTS,
        productsSaga.rearrangeProducts
      ),
      takeEvery(
        SAGA_ACTIONS.PRODUCTS.ADMIN_POPULAR_PRODUCT_SEARCH,
        productsSaga.adminPopularProductSearch
      ),
      takeEvery(
        SAGA_ACTIONS.PRODUCTS.REARRANGE_POPULAR_PRODUCTS,
        productsSaga.rearrangePopularProducts
      ),
      // Vendors
      takeEvery(SAGA_ACTIONS.VENDORS.SEARCH_VENDOR, vendorsSaga.searchVendor),
      takeEvery(
        SAGA_ACTIONS.VENDORS.ADD_UPDATE_VENDOR,
        vendorsSaga.addUpdateVendor
      ),
      takeEvery(SAGA_ACTIONS.VENDORS.DELETE_VENDOR, vendorsSaga.deleteVendor),
      takeEvery(SAGA_ACTIONS.VENDORS.VENDOR_DETAILS, vendorsSaga.vendorDetails),
      takeEvery(SAGA_ACTIONS.VENDORS.CHECK_SKU_UNIQUE, vendorsSaga.checkSKUUnique),

      // Tags
      takeEvery(SAGA_ACTIONS.TAGS.SEARCH_TAG, tagsSaga.searchTag),
      takeEvery(SAGA_ACTIONS.TAGS.ADD_UPDATE_TAG, tagsSaga.addUpdateTag),
      takeEvery(SAGA_ACTIONS.TAGS.DELETE_TAG, tagsSaga.deleteTag),
      takeEvery(SAGA_ACTIONS.TAGS.TAG_DETAILS, tagsSaga.tagDetails),

      //Brands
      takeEvery(SAGA_ACTIONS.BRANDS.SEARCH_BRAND, brandsSaga.searchBrand),
      takeEvery(
        SAGA_ACTIONS.BRANDS.ADD_UPDATE_BRAND,
        brandsSaga.addUpdateBrand
      ),
      takeEvery(SAGA_ACTIONS.BRANDS.DELETE_BRAND, brandsSaga.deleteBrand),
      takeEvery(SAGA_ACTIONS.BRANDS.BRAND_DETAILS, brandsSaga.getBrandDetails),

      // Customers
      takeEvery(
        SAGA_ACTIONS.CUSTOMERS.LIST_CUSTOMER,
        customersSaga.listCustomer
      ),
      takeEvery(
        SAGA_ACTIONS.CUSTOMERS.SEARCH_CUSTOMER,
        customersSaga.searchCustomer
      ),
      takeEvery(
        SAGA_ACTIONS.CUSTOMERS.ADD_UPDATE_CUSTOMER,
        customersSaga.addUpdateCustomer
      ),
      takeEvery(
        SAGA_ACTIONS.CUSTOMERS.DELETE_CUSTOMER,
        customersSaga.deleteCustomer
      ),
      takeEvery(
        SAGA_ACTIONS.CUSTOMERS.CUSTOMER_DETAILS,
        customersSaga.customerDetails
      ),
      takeEvery(
        SAGA_ACTIONS.CUSTOMERS.IMPORT_CUSTOMERS,
        customersSaga.importCustomers
      ),
      takeEvery(
        SAGA_ACTIONS.CUSTOMERS.LIST_CUSTOMER_GROUPS,
        customersSaga.listCustomerGroups
      ),
      takeEvery(
        SAGA_ACTIONS.CUSTOMERS.DELETE_CUSTOMER_GROUP,
        customersSaga.deleteCustomerGroup
      ),
      takeEvery(
        SAGA_ACTIONS.CUSTOMERS.ADD_UPDATE_CUSTOMER_GROUP,
        customersSaga.addUpdateCustomerGroup
      ),
      takeEvery(
        SAGA_ACTIONS.CUSTOMERS.CUSTOMER_GROUP_RULE_MASTER,
        customersSaga.customerGroupRuleMaster
      ),
      takeEvery(
        SAGA_ACTIONS.CUSTOMERS.SEARCH_CUSTOMER_GROUPS,
        customersSaga.searchCustomerGroups
      ),

      takeEvery(
        SAGA_ACTIONS.CUSTOMERS.ADD_UPDATE_CUSTOMER_GROUP_CUSTOM,
        customersSaga.addUpdateCustomerGroupCustom
      ),

      takeEvery(
        SAGA_ACTIONS.CUSTOMERS.GET_CUSTOMER_PROMOTIONS,
        customersSaga.getCustomerPromotions
      ),

      // Discounts
      takeEvery(
        SAGA_ACTIONS.DISCOUNTS.SEARCH_DISCOUNT,
        discountsSaga.searchDiscount
      ),
      takeEvery(
        SAGA_ACTIONS.DISCOUNTS.ADD_UPDATE_DISCOUNT,
        discountsSaga.addUpdateDiscount
      ),
      takeEvery(
        SAGA_ACTIONS.DISCOUNTS.DELETE_DISCOUNT,
        discountsSaga.deleteDiscount
      ),

        //Inventory
        takeEvery(SAGA_ACTIONS.INVENTORY.STOCK_TAKE_LIST, inventorySaga.getStockTakeList),
        takeEvery(SAGA_ACTIONS.INVENTORY.STOCK_TAKE_DELETE, inventorySaga.deleteStockTake),
        takeEvery(SAGA_ACTIONS.INVENTORY.STOCK_TRANSFER_SEARCH, inventorySaga.searchStockTransfer),
        takeEvery(SAGA_ACTIONS.INVENTORY.STOCK_TRANSFER_DELETE, inventorySaga.deleteStockTransfer),
        takeEvery(SAGA_ACTIONS.INVENTORY.RECEIVE_STOCK_TRANSFER, inventorySaga.receiveStockTransfer),
        takeEvery(SAGA_ACTIONS.INVENTORY.SENT_TO_REPAIR_SEARCH, inventorySaga.searchSentToRepair),
        takeEvery(SAGA_ACTIONS.INVENTORY.PENDING_RESTOCK_SEARCH, inventorySaga.searchPendingRestock),
        takeEvery(SAGA_ACTIONS.INVENTORY.PENDING_RESTOCK_INSERT_UPDATE, inventorySaga.insertUpdatePendingRestock),
        takeEvery(SAGA_ACTIONS.INVENTORY.VENDOR_SEARCH, inventorySaga.searchVendors),
        takeEvery(SAGA_ACTIONS.INVENTORY.SCHEDULE_INSERT_UPDATE, inventorySaga.scheduleInsertUpdate),
        takeEvery(SAGA_ACTIONS.INVENTORY.STOCK_TAKE_DETAILS, inventorySaga.getStockTakeDetails),
        takeEvery(SAGA_ACTIONS.INVENTORY.VENDOR_STOCK_RETURN_SEARCH, inventorySaga.searchVendorStockReturn),
        takeEvery(SAGA_ACTIONS.INVENTORY.VENDOR_STOCK_RETURN_DELETE, inventorySaga.deleteVendorStockReturn),
        takeEvery(SAGA_ACTIONS.INVENTORY.VENDOR_STOCK_RETURN_STATUS_CHANGE, inventorySaga.vendorStockReturnStatusChange),
        takeEvery(SAGA_ACTIONS.INVENTORY.VENDOR_STOCK_RETURN_DETAILS, inventorySaga.getVendorStockReturnDetails),
        takeEvery(
            SAGA_ACTIONS.INVENTORY.VENDOR_STOCK_RETURN_INSERT_UPDATE,
            inventorySaga.insertUpdateVendorStockReturn
        ),
        takeEvery(
            SAGA_ACTIONS.INVENTORY.INSERT_UPDATE_STOCK_TRANSFER_WITHIN_LOCATION_TRANSFER,
            inventorySaga.insertUpdateStockTransferWithinLocationTransfer
        ),
        takeEvery(SAGA_ACTIONS.INVENTORY.STOCK_TRANSFER_DETAILS, inventorySaga.getStockTransferDetails),
        takeEvery(SAGA_ACTIONS.INVENTORY.RECEIVE_ORDER_INSERT_UPDATE, inventorySaga.receiveOrderInsertUpdate),
        takeEvery(SAGA_ACTIONS.INVENTORY.PREFERRED_VENDORS, inventorySaga.getPreferredVendors),
        takeEvery(SAGA_ACTIONS.INVENTORY.AUTO_PO_UNASSIGNED_PRODUCTS, inventorySaga.autoPOUnassignedProducts),
        takeEvery(SAGA_ACTIONS.INVENTORY.AUTO_PO_VENDOR_PRODUCTS, inventorySaga.autoPOVendorProducts),
        takeEvery(SAGA_ACTIONS.INVENTORY.MANUAL_PO_UNASSIGNED_PRODUCTS, inventorySaga.manualPOUnassignedProducts),
        takeEvery(SAGA_ACTIONS.INVENTORY.MANUAL_PO_VENDOR_PRODUCTS, inventorySaga.manualPOVendorProducts),
        takeEvery(SAGA_ACTIONS.INVENTORY.INSERT_UPDATE_PO, inventorySaga.insertUpdatePO),
        takeEvery(SAGA_ACTIONS.INVENTORY.CHANGE_VENDOR, inventorySaga.changeVendor),
        // takeEvery(SAGA_ACTIONS.INVENTORY.PURCHASE_ORDER_DETAILS, inventorySaga.getPurchaseOrderDetails),
        takeEvery(SAGA_ACTIONS.INVENTORY.PURCHASE_ORDER_SEARCH, inventorySaga.searchPurchaseOrder),
        takeEvery(SAGA_ACTIONS.INVENTORY.PURCHASE_ORDER_DETAILS, inventorySaga.purchaseOrderDetails),
        takeEvery(SAGA_ACTIONS.INVENTORY.PURCHASE_ORDER_DELETE, inventorySaga.deletePurchaseOrder),
        takeEvery(SAGA_ACTIONS.INVENTORY.RECEIVE_ORDER_SEARCH, inventorySaga.receiveOrderSearch),
        takeEvery(SAGA_ACTIONS.INVENTORY.VENDOR_STOCK_RETURN_RECEIVE_ORDER_SEARCH, inventorySaga.vendorStockReturnReceiveOrderSearch),
        takeEvery(SAGA_ACTIONS.INVENTORY.VENDOR_STOCK_RETURN_RECEIVE_ORDER_INSERT_UPDATE, inventorySaga.vendorStockReturnReceiveOrderInsertUpdate),
        takeEvery(SAGA_ACTIONS.INVENTORY.VENDOR_STOCK_RETURN_RECEIVE_ORDER_DETAILS, inventorySaga.vendorStockReturnReceiveOrderDetails),
        takeEvery(SAGA_ACTIONS.INVENTORY.VENDOR_STOCK_RETURN_RECEIVE_ORDER_DELETE, inventorySaga.vendorStockReturnReceiveOrderDelete),
        takeEvery(SAGA_ACTIONS.INVENTORY.RECEIVE_ORDER_DETAILS, inventorySaga.receiveOrderDetails),
        takeEvery(SAGA_ACTIONS.INVENTORY.RECEIVE_ORDER_DELETE, inventorySaga.deleteReceiveOrder),
        takeEvery(SAGA_ACTIONS.INVENTORY.SEND_EMAIL_TO_VENDOR, inventorySaga.sendEmailToVendor),
        takeEvery(SAGA_ACTIONS.INVENTORY.GET_INBOUND_ORDER_QTY, inventorySaga.getInboundOrderQty),
        takeEvery(SAGA_ACTIONS.INVENTORY.STOCK_COUNT_DETAILS, inventorySaga.getStockCountDetails),
        takeEvery(SAGA_ACTIONS.INVENTORY.START_STOCK_COUNT, inventorySaga.startStockCount),
        takeEvery(SAGA_ACTIONS.INVENTORY.COMPLETE_STOCK_COUNT, inventorySaga.completeStockCount),
        takeEvery(SAGA_ACTIONS.INVENTORY.CHANGE_STOCK_COUNT_STATUS, inventorySaga.changeStockCountStatus),
        takeEvery(SAGA_ACTIONS.INVENTORY.INSERT_PRODUCT, inventorySaga.insertProduct),
        takeEvery(SAGA_ACTIONS.INVENTORY.PURCHASE_ORDER_STATUS_CHANGE, inventorySaga.purchaseOrderStatusChange),
        takeEvery(SAGA_ACTIONS.INVENTORY.PRODUCT_INVENTORY_INSIGHT, inventorySaga.getProductInventoryInsight),
        takeEvery(SAGA_ACTIONS.SETTINGS.STORE_CREDIT_GET, inventorySaga.getStoreCredit),
        takeEvery(SAGA_ACTIONS.SETTINGS.STORE_CREDIT_INSERT_UPDATE, inventorySaga.insertUpdateStoreCredit),

      // Tax
      takeEvery(SAGA_ACTIONS.TAX.REFRESH_COMPANY_RATES, taxSaga.refreshCompanyRates),
      takeEvery(SAGA_ACTIONS.TAX.GET_RATE, taxSaga.getRate),
      takeEvery(SAGA_ACTIONS.TAX.RATE_BULK, taxSaga.rateBulk),

      // Additional Tax
      takeEvery(SAGA_ACTIONS.ADDITIONAL_TAX.GET_APPLICABLE, additionalTaxSaga.getApplicableTaxes),
      takeEvery(SAGA_ACTIONS.TAX.ADDITIONAL_TAX_LIST, taxSaga.additionalTaxList),
      takeEvery(SAGA_ACTIONS.TAX.ADDITIONAL_TAX_INSERT_UPDATE, taxSaga.additionalTaxInsertUpdate),
      takeEvery(SAGA_ACTIONS.TAX.ADDITIONAL_TAX_DETAILS, taxSaga.additionalTaxDetails),
      takeEvery(SAGA_ACTIONS.TAX.ADDITIONAL_TAX_DELETE, taxSaga.additionalTaxDelete),

      // Donation
      takeEvery(SAGA_ACTIONS.DONATION.GET, donationSaga.getDonationSettings),
      takeEvery(SAGA_ACTIONS.DONATION.INSERT_UPDATE, donationSaga.insertUpdateDonationSettings),

      // Cash Discount
      takeEvery(SAGA_ACTIONS.CASH_DISCOUNT.GET, cashDiscountSaga.getCashDiscountSettings),
      takeEvery(SAGA_ACTIONS.CASH_DISCOUNT.INSERT_UPDATE, cashDiscountSaga.insertUpdateCashDiscountSettings),

      // Tip
      takeEvery(SAGA_ACTIONS.TIP.GET, tipSaga.getTipSettings),
      takeEvery(SAGA_ACTIONS.TIP.INSERT_UPDATE, tipSaga.insertUpdateTipSettings),
      takeEvery(SAGA_ACTIONS.SETTINGS_LANGUAGE.GET, settingsLanguageSaga.getLanguageSettings),
      takeEvery(SAGA_ACTIONS.SETTINGS_LANGUAGE.SAVE, settingsLanguageSaga.saveLanguageSettings),
      takeEvery(SAGA_ACTIONS.SETTINGS_MANUAL_PRODUCT_TAXABLE.GET, settingsManualProductTaxableSaga.getManualProductTaxableSettings),
      takeEvery(SAGA_ACTIONS.SETTINGS_MANUAL_PRODUCT_TAXABLE.SAVE, settingsManualProductTaxableSaga.saveManualProductTaxableSettings),

      // Reporting
      takeEvery(SAGA_ACTIONS.REPORTING.REFUND_REPORT, reportingSaga.refundReport),
      takeEvery(SAGA_ACTIONS.REPORTING.SALES_REPORT, reportingSaga.salesReport),
      takeEvery(SAGA_ACTIONS.REPORTING.TIME_CARDS_REPORT, reportingSaga.timeCardsReport),
      takeEvery(SAGA_ACTIONS.REPORTING.TIP_REPORT, reportingSaga.tipReport),
      takeEvery(SAGA_ACTIONS.REPORTING.INVENTORY_MOVEMENT_REPORT, reportingSaga.inventoryMovementReport),
      takeEvery(SAGA_ACTIONS.REPORTING.INVENTORY_STOCK_REPORT, reportingSaga.inventoryStockReport),
      takeEvery(SAGA_ACTIONS.REPORTING.TRANSACTION_REPORT, reportingSaga.transactionReport),
      takeEvery(SAGA_ACTIONS.REPORTING.COMMISSION_REPORT, reportingSaga.commisionReport),
      takeEvery(SAGA_ACTIONS.REPORTING.SALES_BY_LOCATION, reportingSaga.salesByLocation),
      takeEvery(SAGA_ACTIONS.REPORTING.SALES_BY_CATEGORY, reportingSaga.salesByCategory),
      takeEvery(SAGA_ACTIONS.REPORTING.SALES_BY_PRODUCT_TYPE, reportingSaga.salesByProductType),
      takeEvery(SAGA_ACTIONS.REPORTING.SALES_BY_PRODUCT, reportingSaga.salesByProduct),
      takeEvery(SAGA_ACTIONS.REPORTING.SALES_BY_VENDOR, reportingSaga.salesByVendor),
      takeEvery(SAGA_ACTIONS.REPORTING.SALES_BY_DISCOUNT, reportingSaga.salesByDiscount),
      takeEvery(SAGA_ACTIONS.REPORTING.VOID_TRANSACTION, reportingSaga.voidTransaction),
      takeEvery(SAGA_ACTIONS.REPORTING.PO_TERMINALS, reportingSaga.poTerminals),
      takeEvery(SAGA_ACTIONS.REPORTING.GROSS_PROFIT, reportingSaga.grossProfit),
      takeEvery(SAGA_ACTIONS.REPORTING.NET_SALES, reportingSaga.netSales),
      takeEvery(SAGA_ACTIONS.REPORTING.RETURNS, reportingSaga.returns),
      takeEvery(SAGA_ACTIONS.REPORTING.LOYALTY_PROGRAM, reportingSaga.loyaltyProgram),
      takeEvery(SAGA_ACTIONS.REPORTING.STORE_CREDIT, reportingSaga.storeCredit),
      takeEvery(SAGA_ACTIONS.REPORTING.COGS, reportingSaga.cogs),
      takeEvery(SAGA_ACTIONS.REPORTING.TAX, reportingSaga.tax),
      takeEvery(SAGA_ACTIONS.REPORTING.INVENTORY_SUMMARY, reportingSaga.inventorySummary),
      takeEvery(SAGA_ACTIONS.REPORTING.SALES_BY_CUSTOMER_GROUP, reportingSaga.salesByCustomerGroup),
      takeEvery(SAGA_ACTIONS.REPORTING.RETURN_BY_VENDOR, reportingSaga.returnByVendor),
      takeEvery(SAGA_ACTIONS.REPORTING.TOP_SELLING_CATEGORY, reportingSaga.topSellingCategory),
      takeEvery(SAGA_ACTIONS.REPORTING.STOCK_ADJUSTMENT, reportingSaga.stockAdjustmentReport),
      takeEvery(SAGA_ACTIONS.REPORTING.DEPOSIT_REPORT, reportingSaga.depositReport),
      takeEvery(SAGA_ACTIONS.REPORTING.CART_DISCARDED_PRODUCT, reportingSaga.cartDiscardedProduct),
      takeEvery(SAGA_ACTIONS.REPORTING.END_OF_DAY_REPORT, reportingSaga.endOfDayReport),
      takeEvery(SAGA_ACTIONS.REPORTING.CASH_REGISTER_CLOSE_REPORT, reportingSaga.cashRegisterCloseReport),
      takeEvery(SAGA_ACTIONS.REPORTING.BATCH_CLOSE_REPORT, reportingSaga.batchCloseReport),
      takeEvery(SAGA_ACTIONS.REPORTING.SALES_SUMMARY, reportingSaga.salesSummaryReport),
      takeEvery(SAGA_ACTIONS.REPORTING.CASH_DROP_REPORT, reportingSaga.cashDropReport),

      // Loyalty
      takeEvery(SAGA_ACTIONS.LOYALTY.GET_LOYALTY, loyaltySaga.getLoyalty),
      takeEvery(
        SAGA_ACTIONS.LOYALTY.LOYALTY_DETAILS,
        loyaltySaga.loyaltyDetails
      ),
      takeEvery(
        SAGA_ACTIONS.LOYALTY.ADD_UPDATE_LOYALTY,
        loyaltySaga.addUpdateLoyalty
      ),
      takeEvery(SAGA_ACTIONS.LOYALTY.DELETE_LOYALTY, loyaltySaga.deleteLoyalty),
      takeLatest(
        SAGA_ACTIONS.LOYALTY.ACTIVITY_SEARCH,
        loyaltyActivitySaga.loyaltyActivitySearch
      ),
      takeEvery(
        SAGA_ACTIONS.LOYALTY.GET_AVG_CUSTOMER_SPEND,
        loyaltySaga.getAvgCustomerSpend
      ),
      takeEvery(
        SAGA_ACTIONS.LOYALTY.GET_LOYALTY_SALES,
        loyaltySaga.getLoyaltySales
      ),
      takeEvery(
        SAGA_ACTIONS.LOYALTY.GET_TOP_CUSTOMERS,
        loyaltySaga.getTopCustomers
      ),
      takeEvery(
        SAGA_ACTIONS.LOYALTY.GET_CUSTOMER_VISITS,
        loyaltySaga.getCustomerVisits
      ),
      takeEvery(
        SAGA_ACTIONS.LOYALTY.GET_REWARDS_DATA,
        loyaltySaga.getRewardsData
      ),

      // Loyalty Rewards
      takeEvery(
        SAGA_ACTIONS.LOYALTY_REWARD.LIST,
        loyaltyRewardSaga.getLoyaltyRewardList
      ),
      takeEvery(
        SAGA_ACTIONS.LOYALTY_REWARD.DETAILS,
        loyaltyRewardSaga.getLoyaltyRewardDetails
      ),
      takeEvery(
        SAGA_ACTIONS.LOYALTY_REWARD.INSERT_UPDATE,
        loyaltyRewardSaga.insertUpdateLoyaltyReward
      ),
      takeEvery(
        SAGA_ACTIONS.LOYALTY_REWARD.DELETE,
        loyaltyRewardSaga.deleteLoyaltyReward
      ),

      //Settings Return
      takeEvery(
        SAGA_ACTIONS.SETTINGS_RETURN.SETTING_RETURN_INSERT_UPDATE,
        settingsReturnSaga.settingReturnInsertUpdate
      ),
      takeEvery(
        SAGA_ACTIONS.SETTINGS_RETURN.GET_SETTING_RETURN_POLICY,
        settingsReturnSaga.getSettingReturnPolicy
      ),

      // Employee Types
      takeEvery(
        SAGA_ACTIONS.USER_MANAGEMENT.GET_EMPLOYEE_TYPES,
        userManagementSaga.getEmployeeTypes
      ),
      takeEvery(
        SAGA_ACTIONS.USER_MANAGEMENT.UPDATE_EMPLOYEE_TYPES,
        userManagementSaga.updateEmployeeTypes
      ),
      takeEvery(
        SAGA_ACTIONS.USER_MANAGEMENT.DELETE_EMPLOYEE_TYPES,
        userManagementSaga.deleteEmployeeTypes
      ),

      // Pay Types
      takeEvery(
        SAGA_ACTIONS.USER_MANAGEMENT.GET_PAY_TYPES,
        userManagementSaga.getPayTypes
      ),
      takeEvery(
        SAGA_ACTIONS.USER_MANAGEMENT.UPDATE_PAY_TYPES,
        userManagementSaga.updatePayTypes
      ),
      takeEvery(
        SAGA_ACTIONS.USER_MANAGEMENT.DELETE_PAY_TYPES,
        userManagementSaga.deletePayTypes
      ),

        //users
        takeEvery(SAGA_ACTIONS.USER_MANAGEMENT.SEARCH_USERS, userManagementSaga.searchUsers),
        takeEvery(SAGA_ACTIONS.USER_MANAGEMENT.INSERT_UPDATE_USER, userManagementSaga.insertUpdateUser),
        takeEvery(SAGA_ACTIONS.USER_MANAGEMENT.DELETE_USER, userManagementSaga.deleteUser),
        takeEvery(SAGA_ACTIONS.USER_MANAGEMENT.GET_USER_DETAILS, userManagementSaga.getUserDetails),
        takeEvery(SAGA_ACTIONS.USER_MANAGEMENT.GET_USER_SCHEDULE, userManagementSaga.getUserSchedule),
        takeEvery(SAGA_ACTIONS.USER_MANAGEMENT.SEARCH_USER_SCHEDULE, userManagementSaga.searchUserSchedule),
        takeEvery(SAGA_ACTIONS.USER_MANAGEMENT.INSERT_UPDATE_USER_SCHEDULE, userManagementSaga.insertUpdateUserSchedule),
        takeEvery(SAGA_ACTIONS.USER_MANAGEMENT.GET_USER_SCHEDULE_BY_ID, userManagementSaga.getUserScheduleById),
        takeEvery(SAGA_ACTIONS.USER_MANAGEMENT.VALIDATE_MPIN, userManagementSaga.validateMpin),

      // Gift Cards
      takeEvery(
        SAGA_ACTIONS.GIFT_CARDS.CATEGORY_INSERT_UPDATE,
        giftCardsSaga.categoryInsertUpdate
      ),
      takeEvery(
        SAGA_ACTIONS.GIFT_CARDS.CATEGORY_DETAILS_BY_ID,
        giftCardsSaga.categoryDetailsById
      ),
      takeEvery(
        SAGA_ACTIONS.GIFT_CARDS.CATEGORY_SEARCH,
        giftCardsSaga.categorySearch
      ),
      takeEvery(
        SAGA_ACTIONS.GIFT_CARDS.CATEGORY_LIST,
        giftCardsSaga.categoryList
      ),
      takeEvery(
        SAGA_ACTIONS.GIFT_CARDS.CONFIGURATION_INSERT_UPDATE,
        giftCardsSaga.configurationInsertUpdate
      ),
      takeEvery(
        SAGA_ACTIONS.GIFT_CARDS.CONFIGURATION_SEARCH,
        giftCardsSaga.configurationSearch
      ),
      takeEvery(
        SAGA_ACTIONS.GIFT_CARDS.PHYSICAL_GIFT_CARD_SEARCH,
        giftCardsSaga.physicalGiftCardSearch
      ),
      takeEvery(
        SAGA_ACTIONS.GIFT_CARDS.HISTORY_SEARCH,
        giftCardsSaga.historySearch
      ),
      takeEvery(
        SAGA_ACTIONS.GIFT_CARDS.GENERAL_GIFT_CARD_SEARCH,
        giftCardsSaga.generalGiftCardSearch
      ),

        // Role Permissions
        takeEvery(SAGA_ACTIONS.USER_MANAGEMENT.GET_ROLE_PERMISSION, userManagementSaga.getRolePermission),
        takeEvery(SAGA_ACTIONS.USER_MANAGEMENT.ROLE_LIST, userManagementSaga.getRoleList),
        takeEvery(SAGA_ACTIONS.USER_MANAGEMENT.INSERT_UPDATE_ROLE_PERMISSION, userManagementSaga.insertUpdateRolePermission),
        takeEvery(SAGA_ACTIONS.USER_MANAGEMENT.DELETE_ROLE_PERMISSION, userManagementSaga.deleteRolePermission),
        // Notifications
        takeEvery(SAGA_ACTIONS.NOTIFICATIONS.GET_NOTIFICATION_REMINDERS, notificationsSaga.getNotificationReminders),
        takeEvery(SAGA_ACTIONS.NOTIFICATIONS.INSERT_UPDATE_NOTIFICATION_REMINDERS, notificationsSaga.insertUpdateNotificationReminders),
        //orders and fulfillment
        takeEvery(SAGA_ACTIONS.ORDERS_AND_FULFILLMENT.GET_SEARCH_ORDERS, orderandfulfillmentSaga.getSearchOrders),
        takeEvery(SAGA_ACTIONS.ORDERS_AND_FULFILLMENT.GET_ORDER_DETAILS, orderandfulfillmentSaga.getOrderDetails),
        takeEvery(SAGA_ACTIONS.ORDERS_AND_FULFILLMENT.GET_RETURN_ORDER_DETAILS, orderandfulfillmentSaga.getReturnOrderDetails),

        //Agreement Policies
        takeEvery(SAGA_ACTIONS.AGREEMENT_POLICIES.GET_AGREEMENT_POLICIES, agreementsSaga.getAgreementPolicies),
        takeEvery(SAGA_ACTIONS.AGREEMENT_POLICIES.DELETE_AGREEMENT_POLICY, agreementsSaga.deleteAgreementPolicy),
        takeEvery(SAGA_ACTIONS.AGREEMENT_POLICIES.INSERT_UPDATE_POLICY, agreementsSaga.insertUpdateAgreementPolicy),
        takeEvery(SAGA_ACTIONS.AGREEMENT_POLICIES.GET_POLICY_BY_ID, agreementsSaga.getPolicyById),

        //Templates
        takeEvery(SAGA_ACTIONS.TEMPLATES.GET_MESSAGE_TEMPLATE, templateSaga.getMessageTemplate),
        takeEvery(SAGA_ACTIONS.TEMPLATES.INSERT_UPDATE_MESSAGE_TEMPLATE, templateSaga.insertUpdateMessageTemplate),
        takeEvery(SAGA_ACTIONS.TEMPLATES.GET_EMAIL_TEMPLATE, templateSaga.getEmailTemplate),
        takeEvery(SAGA_ACTIONS.TEMPLATES.INSERT_UPDATE_EMAIL_TEMPLATE, templateSaga.insertUpdateEmailTemplate),

        //company details
        takeEvery(SAGA_ACTIONS.COMPANY.GET_COMPANY_DETAILS, companySaga.getCompanyDetails),
        takeEvery(SAGA_ACTIONS.COMPANY.UPDATE_COMPANY_DETAILS, companySaga.updateCompanyDetails),
       
        // Settings Payment Type
        takeEvery(
        SAGA_ACTIONS.SETTINGS_PAYMENT_TYPE.MASTER_GET,
        settingsPaymentTypeSaga.masterGetPaymentType
        ),
        takeEvery(
          SAGA_ACTIONS.SETTINGS_PAYMENT_TYPE.GET,
          settingsPaymentTypeSaga.getPaymentType
        ),
        takeEvery(
          SAGA_ACTIONS.SETTINGS_PAYMENT_TYPE.INSERT_UPDATE,
          settingsPaymentTypeSaga.insertUpdatePaymentType
        ),
        takeEvery(
          SAGA_ACTIONS.SETTINGS_PAYMENT_TYPE.DETAILS_BY_ID,
          settingsPaymentTypeSaga.detailsByIdPaymentType
        ),
        takeEvery(
          SAGA_ACTIONS.SETTINGS_PAYMENT_TYPE.DELETE,
          settingsPaymentTypeSaga.deletePaymentType
        ),
        takeEvery(
          SAGA_ACTIONS.SETTINGS_PAYMENT_TYPE.STATUS_CHANGE,
          settingsPaymentTypeSaga.statusChangePaymentType
        ),

        // Receipt template Sagas
        takeEvery(SAGA_ACTIONS.RECEIPT_TEMPLATE.INSERT_UPDATE, templateSaga.insertUpdateReceiptTemplate),
        takeEvery(SAGA_ACTIONS.RECEIPT_TEMPLATE.DETAILS_BY_ID, templateSaga.getReceiptTemplateDetails),
        takeEvery(
            SAGA_ACTIONS.DASHBOARD.GET_TOTAL_REVENUE,
            dashboardSaga.getTotalRevenue
        ),
        takeEvery(
            SAGA_ACTIONS.DASHBOARD.GET_AVG_SALES_TICKET,
            dashboardSaga.getAvgSalesTicket
        ),
        takeEvery(
            SAGA_ACTIONS.DASHBOARD.GET_EXPENSE_TOTAL,
            dashboardSaga.getExpenseTotal
        ),
        takeEvery(
            SAGA_ACTIONS.DASHBOARD.GET_GROSS_MARGIN_PERCENTAGE,
            dashboardSaga.getGrossMarginPercentage
        ),
        takeEvery(
            SAGA_ACTIONS.DASHBOARD.GET_ONLINE_VS_OFFLINE,
            dashboardSaga.getOnlineVsOffline
        ),
        takeEvery(
            SAGA_ACTIONS.DASHBOARD.GET_REPEAT_CUSTOMER_PERCENTAGE,
            dashboardSaga.getRepeatCustomerPercentage
        ),
        takeEvery(
            SAGA_ACTIONS.DASHBOARD.GET_GROSS_MARGIN_CHART,
            dashboardSaga.getGrossMarginChart
        ),
        takeEvery(
            SAGA_ACTIONS.DASHBOARD.GET_REVENUE_EXPENSE_CHART,
            dashboardSaga.getRevenueExpenseChart
        ),
        takeEvery(
            SAGA_ACTIONS.DASHBOARD.GET_PURCHASE_COST_CHART,
            dashboardSaga.getPurchaseCostChart
        ),
        takeEvery(
            SAGA_ACTIONS.DASHBOARD.GET_SALES_VOLUME_CHART,
            dashboardSaga.getSalesVolumeChart
        ),
        takeEvery(
            SAGA_ACTIONS.DASHBOARD.GET_TOP_PRODUCTS,
            dashboardSaga.getTopProducts
        ),
        takeEvery(
            SAGA_ACTIONS.DASHBOARD.GET_TOP_PROMOTIONS,
            dashboardSaga.getTopPromotions
        ),
        takeEvery(
            SAGA_ACTIONS.DASHBOARD.GET_TOP_CATEGORIES,
            dashboardSaga.getTopCategories
        ),
        takeEvery(
            SAGA_ACTIONS.DASHBOARD.GET_TOP_SALES_PERSON,
            dashboardSaga.getTopSalesPerson
        ),
        takeEvery(
            SAGA_ACTIONS.DASHBOARD.GET_EMPLOYEE_WORK_TIME,
            dashboardSaga.getEmployeeWorkTime
        ),
        takeEvery(
            SAGA_ACTIONS.DASHBOARD.GET_CUSTOMER_COMPARISON,
            dashboardSaga.getCustomerComparison
        ),
        takeEvery(
          SAGA_ACTIONS.DASHBOARD.GET_AVG_SALES_TICKET_COMPARISON,
          dashboardSaga.getAvgSalesTicketComparison
        ),
        takeEvery(
          SAGA_ACTIONS.DASHBOARD.GET_REPEAT_CUSTOMER_COMPARISON,
          dashboardSaga.getRepeatCustomerComparison
        ),
        takeEvery(
          SAGA_ACTIONS.DASHBOARD.GET_GROSS_SALES_NET_SALES_CHART,
          dashboardSaga.getGrossSalesNetSalesChart
        ),
        takeEvery(
          SAGA_ACTIONS.DASHBOARD.GET_GROSS_COST_LABOR_COST_CHART,
          dashboardSaga.getGrossCostLaborCostChart
        ),
        takeEvery(
          SAGA_ACTIONS.DASHBOARD.GET_RETURNS_REFUNDS_TREND,
          dashboardSaga.getReturnsRefundsTrend
        ),
        takeEvery(
          SAGA_ACTIONS.DASHBOARD.GET_VOIDS_CANCELLATIONS,
          dashboardSaga.getVoidsCancellations
        ),
        takeEvery(
          SAGA_ACTIONS.DASHBOARD.GET_TRANSACTION_VOLUME,
          dashboardSaga.getTransactionVolume
        ),
        takeEvery(
          SAGA_ACTIONS.DASHBOARD.GET_SALES_BY_PAYMENT_METHOD,
          dashboardSaga.getSalesByPaymentMethod
        ),
        takeEvery(
          SAGA_ACTIONS.DASHBOARD.GET_POINTS_ISSUED_BY_LOYALTY_TYPE,
          dashboardSaga.getPointsIssuedByLoyaltyType
        ),
        takeEvery(
          SAGA_ACTIONS.DASHBOARD.GET_SALES_TREND_BY_HOUR,
          dashboardSaga.getSalesTrendByHour
        ),
        takeEvery(
          SAGA_ACTIONS.DASHBOARD.GET_SALES_BREAKDOWN,
          dashboardSaga.getSalesBreakdown
        ),
        takeEvery(
          SAGA_ACTIONS.DASHBOARD.GET_POINTS_REDEEMED_BY_LOYALTY_TYPE,
          dashboardSaga.getPointsRedeemedByLoyaltyType
        ),
        takeEvery(
          SAGA_ACTIONS.DASHBOARD.GET_PARTICIPATION_RATE_BY_LOYALTY_TYPE,
          dashboardSaga.getParticipationRateByLoyaltyType
        ),
        takeEvery(
          SAGA_ACTIONS.DASHBOARD.GET_GROSS_SALES,
          dashboardSaga.getGrossSales
        ),
        takeEvery(
          SAGA_ACTIONS.DASHBOARD.GET_NET_SALES,
          dashboardSaga.getNetSales
        ),
        takeEvery(
          SAGA_ACTIONS.DASHBOARD.GET_COST_OF_GOODS_SOLD,
          dashboardSaga.getCostOfGoodsSold
        ),
        takeEvery(
          SAGA_ACTIONS.DASHBOARD.GET_GROSS_MARGIN,
          dashboardSaga.getGrossMargin
        ),
        takeEvery(
          SAGA_ACTIONS.DASHBOARD.GET_LABOR_COST,
          dashboardSaga.getLaborCost
        ),
        takeEvery(
          SAGA_ACTIONS.DASHBOARD.GET_NUM_OF_TRANSACTIONS,
          dashboardSaga.getNumOfTransactions
        ),
        takeEvery(
          SAGA_ACTIONS.DASHBOARD.GET_LOW_PERFORMING_PRODUCTS,
          dashboardSaga.getLowPerformingProducts
        ),

        // Feedback
        takeEvery(
            SAGA_ACTIONS.FEEDBACK.GET_CUSTOMER_FEEDBACK_DETAILS,
            feedbackSaga.getCustomerFeedbackDetails
        ),
        takeEvery(
            SAGA_ACTIONS.FEEDBACK.INSERT_FEEDBACK,
            feedbackSaga.insertFeedback
        ),

        // Product Import
        takeEvery(
            SAGA_ACTIONS.PRODUCT_IMPORT.IMPORT_PRODUCTS,
            productImportSaga.importProducts
        ),
        takeEvery(
            SAGA_ACTIONS.FEEDBACK.GET_FEEDBACK_LIST,
            feedbackSaga.getFeedbackList
        ),
        takeEvery(
            SAGA_ACTIONS.FEEDBACK.GET_SETTINGS,
            feedbackSaga.getFeedbackSettings
        ),
        takeEvery(
            SAGA_ACTIONS.FEEDBACK.SAVE_SETTINGS,
            feedbackSaga.saveFeedbackSettings
        ),

        // Lottery
        takeEvery(SAGA_ACTIONS.LOTTERY.SEARCH, lotterySaga.searchLottery),
        takeEvery(SAGA_ACTIONS.LOTTERY.DETAILS, lotterySaga.lotteryDetails),
        takeEvery(SAGA_ACTIONS.LOTTERY.INSERT_UPDATE, lotterySaga.addUpdateLottery),
        takeEvery(SAGA_ACTIONS.LOTTERY.DELETE, lotterySaga.deleteLottery),
        takeEvery(SAGA_ACTIONS.LOTTERY.TICKET_SEARCH, lotterySaga.ticketSearch),
        takeEvery(SAGA_ACTIONS.LOTTERY.TICKET_EXPORT, lotterySaga.ticketExport),
        takeEvery(SAGA_ACTIONS.LOTTERY.BOOKLET_DELETE, lotterySaga.bookletDelete),
        takeEvery(SAGA_ACTIONS.LOTTERY.CHECK_BOOKLET_UNIQUE, lotterySaga.checkBookletUnique),
        takeEvery(SAGA_ACTIONS.LOTTERY.LOOKUP_BARCODE, lotterySaga.lookupBarcode),
        takeEvery(SAGA_ACTIONS.LOTTERY.BOOKLET_PARSED_ADD, lotterySaga.bookletParsedAdd),

        // Marketing Automation
        takeEvery(SAGA_ACTIONS.MARKETING_CAMPAIGN.SEARCH, marketingSaga.searchCampaign),
        takeEvery(SAGA_ACTIONS.MARKETING_CAMPAIGN.INSERT_UPDATE, marketingSaga.insertUpdateCampaign),
        takeEvery(SAGA_ACTIONS.MARKETING_CAMPAIGN.DELETE, marketingSaga.deleteCampaign),
        takeEvery(SAGA_ACTIONS.MARKETING_CAMPAIGN.DETAILS, marketingSaga.campaignDetails),
        takeEvery(SAGA_ACTIONS.MARKETING_CAMPAIGN.DELIVERIES, marketingSaga.campaignDeliveries),
        takeEvery(SAGA_ACTIONS.MARKETING_AUDIENCE_LIST.SEARCH, marketingSaga.searchAudienceList),
        takeEvery(SAGA_ACTIONS.MARKETING_AUDIENCE_LIST.INSERT_UPDATE, marketingSaga.insertUpdateAudienceList),
        takeEvery(SAGA_ACTIONS.MARKETING_AUDIENCE_LIST.DELETE, marketingSaga.deleteAudienceList),
        takeEvery(SAGA_ACTIONS.MARKETING_AUDIENCE_LIST.DETAILS, marketingSaga.audienceListDetails),
        takeEvery(SAGA_ACTIONS.MARKETING_AUDIENCE_LIST.BULK_UPSERT_MEMBERS, marketingSaga.bulkUpsertMembers),
        takeEvery(SAGA_ACTIONS.MARKETING_AUDIENCE_LIST.ADD_FROM_GROUPS, marketingSaga.addFromGroups),
        takeEvery(SAGA_ACTIONS.MARKETING.MASTER_TAGS, marketingSaga.getMasterTags),
        takeEvery(SAGA_ACTIONS.MARKETING.VALIDATE_TAGS, marketingSaga.validateTags),
        takeEvery(SAGA_ACTIONS.MARKETING.PREVIEW_CONTENT, marketingSaga.previewContent),
        takeEvery(SAGA_ACTIONS.MARKETING.GET_SETTINGS, marketingSaga.getSettings),
        takeEvery(SAGA_ACTIONS.MARKETING.SAVE_EMAIL_SETTINGS, marketingSaga.saveEmailSettings),
        takeEvery(SAGA_ACTIONS.MARKETING.SAVE_SMS_SETTINGS, marketingSaga.saveSmsSettings),

        // Deposits
        takeEvery(SAGA_ACTIONS.DEPOSITS.GET, depositsSaga.getDeposits),
        takeEvery(SAGA_ACTIONS.DEPOSITS.ADD, depositsSaga.addDeposit),
        takeEvery(SAGA_ACTIONS.DEPOSITS.UPDATE, depositsSaga.updateDeposit),
        takeEvery(SAGA_ACTIONS.DEPOSITS.DELETE, depositsSaga.deleteDeposit),

        // QuickBooks
        takeEvery(SAGA_ACTIONS.QUICKBOOKS.SETUP_STATUS, quickbooksSaga.getSetupStatus),
        takeEvery(SAGA_ACTIONS.QUICKBOOKS.SAVE_SETUP, quickbooksSaga.saveSetup),
        takeEvery(SAGA_ACTIONS.QUICKBOOKS.CONNECT, quickbooksSaga.connect),
        takeEvery(SAGA_ACTIONS.QUICKBOOKS.DISCONNECT, quickbooksSaga.disconnect),
        takeEvery(SAGA_ACTIONS.QUICKBOOKS.DELETE_SETUP, quickbooksSaga.deleteSetup),
        takeEvery(SAGA_ACTIONS.QUICKBOOKS.MANUAL_SYNC_STATUS, quickbooksSaga.getManualSyncStatus),
        takeEvery(SAGA_ACTIONS.QUICKBOOKS.MANUAL_SYNC_TRIGGER, quickbooksSaga.triggerManualSync),
        takeEvery(SAGA_ACTIONS.QUICKBOOKS.MANUAL_SYNC_LOG, quickbooksSaga.getManualSyncLog),
        takeEvery(SAGA_ACTIONS.QUICKBOOKS.MANUAL_SYNC_RETRY, quickbooksSaga.retryManualSync),
        takeEvery(SAGA_ACTIONS.QUICKBOOKS.OUTBOX_STATUS, quickbooksSaga.getOutboxStatus),
        takeEvery(SAGA_ACTIONS.QUICKBOOKS.OUTBOX_LOG, quickbooksSaga.getOutboxLog),
        takeEvery(SAGA_ACTIONS.QUICKBOOKS.OUTBOX_RETRY, quickbooksSaga.retryOutbox),
        takeEvery(SAGA_ACTIONS.QUICKBOOKS.OUTBOX_RETRY_ALL, quickbooksSaga.retryAllOutbox),
    ]);
}
